// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".red[data-v-82583cb2] {\n  color: #ed4014;\n}", ""]);
// Exports
module.exports = exports;
